import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { ajaxRetry } from '../../lib-api/ajaxRetry';
import { base, createApiURL, ResponseObj } from '../../lib-api/services/base';
import { CreateRiskInsightsResponse } from '../models/riskInsights';
import { ApplicationError } from '../../components/ApplicationErrorBoundary/errors/ApplicationError';

export const ERR_RISK_INSIGHTS_FAILED_TO_CREATE_REPORT = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_CREATE_RISK_INSIGHTS_REPORT,
};

export interface RiskInsightsService {
  createRiskInsights: () => Promise<CreateRiskInsightsResponse>;
}

export interface RiskInsightsClient {
  createRiskInsights: () => Promise<ResponseObj<CreateRiskInsightsResponse | undefined>>;
}

export const riskInsightsClient: RiskInsightsClient = {
  createRiskInsights: () => {
    return ajaxRetry<CreateRiskInsightsResponse>({
      headers: base.headers(),
      method: 'POST',
      url: createApiURL(`/risk/v1/risk-insights`),
    });
  },
};

export function createRiskInsightsService(client: RiskInsightsClient): RiskInsightsService {
  return {
    createRiskInsights: async () => {
      const response = await client.createRiskInsights();

      if (response.isOk() && response.data) {
        return response.data;
      }

      throw new ApplicationError(ERR_RISK_INSIGHTS_FAILED_TO_CREATE_REPORT);
    },
  };
}

export const riskInsightsService = createRiskInsightsService(riskInsightsClient);
